import { cn } from '@tractian/ui'

type SkeletonProps = {
  lines?: number
  className?: string
  'data-testid'?: string
}

export function Skeleton({ lines = 1, className = '', 'data-testid': dataTestId }: SkeletonProps) {
  return (
    <div role="status" aria-label="Loading" className={className} data-testid={dataTestId}>
      {Array.from({ length: lines }, (_, i) => (
        <div key={i} className="mb-2 h-4 animate-pulse rounded bg-gray-200" />
      ))}
    </div>
  )
}

type SkeletonBarProps = {
  className?: string
  'data-testid'?: string
}

/**
 * A single shimmering block. Building block for structured skeletons that mirror
 * real content — size it with height/width utilities via `className`. Prefer this
 * over `Skeleton` (flat lines) when the placeholder should match a specific shape
 * (an input, an icon, a label).
 */
export function SkeletonBar({ className, 'data-testid': dataTestId }: SkeletonBarProps) {
  return (
    <div
      data-testid={dataTestId}
      className={cn('animate-pulse rounded bg-gray-200', className)}
      aria-hidden
    />
  )
}
